export default function initAccordion() {
  Alpine.data('accordion', () => ({
    opened: '0',
    toggleOpen(id: string) {
      const content = document.getElementById(`accordion-content-${id}`);
      const oldId = this.opened;
      this.opened = (this.opened === id) ? '0' : id;
      if (oldId !== '0' && oldId !== id) {
        const oldContent = document.getElementById(`accordion-content-${oldId}`);
        if (oldContent) {
          const oldInnerWrap = oldContent.querySelector('.accordion-inner-wrap');
          oldContent.style.maxHeight = '';
          setTimeout(() => oldInnerWrap?.classList.add('hidden'), 200);
        }
      }
      if (content) {
        const innerWrap = content.querySelector('.accordion-inner-wrap');
        if (content.classList.contains('max-h-0!')) {
          innerWrap?.classList.remove('hidden');
          content.style.maxHeight = `${content.scrollHeight}px`;
        } else {
          content.style.maxHeight = '';
          setTimeout(() => innerWrap?.classList.add('hidden'), 200);
        }
      }
    },
    isOpened(id: string) {
      return this.opened === id;
    },
    contentClasses(id: string) {
      return { 'max-h-0!': !this.isOpened(id) };
    },
    itemClasses(id: string) {
      return { 'active' : this.isOpened(id) };
    }
  }));
}
